import React from "react"

function IconFileMagnifyingGlass({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="file-magnifying-glass"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-file-magnifying-glass"
      {...props}
    >
      <path
        d="M13.455 21.852a6.566 6.566 0 0 1-2.182-1.311H5.02a.473.473 0 0 1-.464-.387l-.008-.085V3.959c0-.23.167-.423.388-.463l.084-.008 9.626.001v4.76l.009.107a.655.655 0 0 0 .54.54l.106.008h4.212l.002 1.677c.492.346.933.757 1.31 1.221l-.001-3.99a.655.655 0 0 0-.122-.379l-.065-.078-4.87-4.98a.655.655 0 0 0-.363-.188l-.104-.008H5.02c-.93 0-1.696.715-1.774 1.627l-.007.153v16.11c0 .932.717 1.697 1.628 1.775l.153.006 8.434.002zm2.5-14.256V4.44l3.086 3.154h-3.085zm5.629 15.52a.655.655 0 0 0 .942-.878l-.072-.093-3.19-3.42a4.66 4.66 0 1 0-.963.886l3.195 3.426.088.08zm-5.922-3.995a3.35 3.35 0 1 1-.001-6.7 3.35 3.35 0 0 1 0 6.7z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFileMagnifyingGlass
